<template>
	<div class="error-wrapper">
		<div class="error">
			<div class="top-area">
        <img src="@/assets/site/images/onlinerequest/logo/logo_notFound.png" alt ="icon" class="logo img" />
			</div>

			<div class="bottom-area">
				<div class="tit-area">
<!--           <img src="@/assets/images/portal/icon/notfound/icon_sad.svg" alt ="icon" class="icon img" /> -->
					<h3 class="tit">
            <v-icon class="material-icons">error</v-icon>
            <span>페이지를 찾을 수 없습니다.</span>
          </h3>
				</div>
				<div class="txt-area">
					<p>
						방문하시려는 페이지의 주소가 잘못 입력되었거나,<br />
						페이지의 주소가 변경 혹은 삭제되어 요청하신 페이지를 찾을 수 없습니다.
					</p>
          <p>입력하신 주소가 정확한지 다시 한번 확인해 주시기 바랍니다</p>
				</div>
				<div class="btn-area">
          <v-btn depressed>
            <nuxt-link to="/">돌아가기</nuxt-link>
          </v-btn>
				</div>
				<div class="logo-area">
          <img v-if="isDemo" src="~@/assets/site/images/onlinerequest/logo/demo/logo.png" alt="리마커블 소프트">
          <img v-else src="~@/assets/site/images/onlinerequest/logo/logo.png" alt="footerLogo">
        </div>
			</div>
		</div>
	</div>
</template>
<script>

export default {
  data() {
    return {
      // 데모 버전인지 확인
      isDemo: $nuxt.$constant.FLAG_YN.YES === process.env.IS_DEMO_YN,
    }
  },
	components: {},
	created() {},
	computed: {},
	mounted() {
    // 데모버전일 경우 attribute 추가
    if( this.isDemo ) {
      document.documentElement.setAttribute("demo", "true");
    }
  },
};
</script>

<style lang="scss">
@import "../../assets/site/scss/pages/notFound/notFound";
</style>
